module.exports = __webpack_public_path__ + "img/notice-banner.db6f67c7.png";